import ResetAtmCodeComponent from './reset_atm_code.component'
import ResetAtmCodeAll from './all'

let resetAtmCodeModule = angular.module('resetAtmCode', [
    ResetAtmCodeAll
])

    .component('resetAtmCode', ResetAtmCodeComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider

            .state('reset-atm-code.all', {
                url: '/all/:page',
                component: 'resetAtmCodeAll'
            })
    })
    .name;

export default resetAtmCodeModule;


// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/index.js